import { db } from '../../config/Fire';
import * as Constants from './../../constants/nodes_database';

export const ADD_SERVICE = 'ADD_SERVICE';
export const SAVING_SERVICES = 'SAVING_SERVICES';
export const SAVED_SERVICES = 'SAVED_SERVICES';

const setServiceAdded = payload => ({ type: ADD_SERVICE, payload });
export const setSavingServices = payload => ({ type: SAVING_SERVICES, payload });
export const setSavedServices = payload => ({ type: SAVED_SERVICES, payload });

export const addServiceAdmin = payload => {
    return dispatch => {
        var isSavingServices = true;
        dispatch(setSavingServices(isSavingServices));
        const { service, services } = payload;
        var myRef = db.ref(`${Constants.SERVICES}`).push();
        var key = myRef.key;
        service.id = key;
        return myRef.set({ 
            name: service.name,
            icon: service.icon,
            id: service.id
        })
        .then(() => {
            //console.log("getRestaurant: " + JSON.stringify(restaurant));
            services[service.id] = service;
            dispatch(setServiceAdded(services));
            dispatch(setSavingServices(isSavingServices = false));
            var isSavedServices = true;
            dispatch(setSavedServices(isSavedServices));
        })
        .catch(err => {
            console.log("not found save data " + err);
            dispatch(setSavingServices(isSavingServices = false));
        });
    };
};